// Use an isolated request: the legacy Axios interceptor replaces Authorization
// with Firebase tokens and retries 401s. Privy credentials must never take that path.
export async function exchangePrivyToken({baseUrl, accessToken, fetchImpl = fetch}) {
  if (!accessToken) throw new Error('Privy session expired. Please sign in again.');
  const response = await fetchImpl(`${baseUrl.replace(/\/$/, '')}/user/privy-login`, {
    method: 'POST',
    headers: {Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json'},
    body: '{}',
    signal: AbortSignal.timeout(15000),
  });
  if (!response.ok) {
    if (response.status === 409) throw new Error('Your Privy login works. Your existing NEXUS account still needs to be linked.');
    if (response.status === 404 || response.status === 503) throw new Error('Privy connected. The NEXUS account migration service is not enabled yet.');
    throw new Error('NEXUS could not verify your Privy session. Please sign in again.');
  }
  const result = await response.json();
  if (typeof result.token !== 'string' || !result.token) throw new Error('NEXUS did not return a valid session.');
  return result;
}
